import { IUser } from 'src/interfaces/auth/auth.interface'
import {
  CheckoutSteps,
  ICheckout,
  IDiscountData,
  IInstallationValues,
  ILinkIntegrator,
  IPaymentMethod,
  IProductConstraint,
  IProposalData,
  IProposalUpdate,
  IQuoteItem,
  IShipping,
  KitType,
  StoreChargers,
  TabFilters,
} from './quote.meta.model'
import { StoreKit } from 'src/interfaces/kit/kit.interface'

export class ResetQuoteStateAction {
  public static readonly type = '[QuoteMeta] Reset to Initial State'
}

export class SetQuoteDataItemAction {
  public static readonly type = '[QuoteMeta] Set Quote Data Item'
  constructor(public payload: { item: string; data: IQuoteItem[] | any[] }) {}
}

export class UpdateQuoteItemAction {
  public static readonly type = '[QuoteMeta] Update Quote Item'
  constructor(public payload: { item: string; data: IQuoteItem }) {}
}

export class SetCheckoutDataAction {
  public static readonly type = '[QuoteMeta] Set Checkout Data'
  constructor(public payload: Partial<ICheckout>) {}
}

export class SetInvoiceToAction {
  public static readonly type = '[QuoteMeta] Set Invoice To'
  constructor(public payload: any) {}
}

export class SetDeliveryToAction {
  public static readonly type = '[QuoteMeta] Set Delivery To'
  constructor(public payload: any) {}
}

export class SetInstallationValuesAction {
  public static readonly type = '[QuoteMeta] Set Installation Values'
  constructor(public payload: IInstallationValues) {}
}

export class SetDiscountAction {
  public static readonly type = '[QuoteMeta] Set Discount'
  constructor(public payload: IDiscountData) {}
}

export class SetDiscountCouponAction {
  public static readonly type = '[QuoteMeta] Set Discount Coupon'
  constructor(public payload: string) {}
}

export class SetRebateValueAction {
  public static readonly type = '[QuoteMeta] Set Rebate Value'
  constructor(public payload: number) {}
}

export class SetTotalRebateCreditAction {
  public static readonly type = '[QuoteMeta] Set Total Rebate Credit'
  constructor(public payload: number) {}
}

export class SetCheckoutStepAction {
  public static readonly type = '[QuoteMeta] Set Checkout Step'
  constructor(public payload: CheckoutSteps) {}
}

export class SetPaymentMethodAction {
  public static readonly type = '[QuoteMeta] Set Payment Method'
  constructor(public payload: IPaymentMethod) {}
}

export class SetPaymentOriginAction {
  public static readonly type = '[QuoteMeta] Set Payment Origin'
  constructor(public payload: string) {}
}

export class SetPaymentTypeAction {
  public static readonly type = '[QuoteMeta] Set Payment Type'
  constructor(public payload: string) {}
}
export class SetProposalDataAction {
  public static readonly type = '[QuoteMeta] Set Proposal Data'
  constructor(public payload: IProposalData) {}
}

export class AddProposalUpdateAction {
  public static readonly type = '[QuoteMeta] Add Proposal Update'
  constructor(public payload: IProposalUpdate) {}
}

export class RemoveProposalUpdateAction {
  public static readonly type = '[QuoteMeta] Remove Proposal Update'
  constructor(public payload: string) {}
}

export class UploadFilesAction {
  public static readonly type = '[QuoteMeta] Upload Files'
  constructor(public payload: any[]) {}
}

export class RemoveFileAction {
  public static readonly type = '[QuoteMeta] Remove File'
  constructor(public payload: string) {}
}

export class SetShippingAction {
  public static readonly type = '[QuoteMeta] Set Shipping'
  constructor(public payload: IShipping) {}
}

export class UpdateQuoteItemQuantityAction {
  public static readonly type = '[QuoteMeta] Update Quote Item Quantity'
  constructor(public payload: { item: string; id: string; quantity: number }) {}
}

export class SetProductsConstraintsAction {
  public static readonly type = '[QuoteMeta] Set Products Constraints'
  constructor(public payload: IProductConstraint[]) {}
}

export class SetTabFilterAction {
  public static readonly type = '[QuoteMeta] Set Tab Filter'
  constructor(public payload: TabFilters) {}
}

export class RemoveAllSelectedTabItemsAction {
  public static readonly type = '[QuoteMeta] Remove All Selected Tab Items'
  constructor(public payload: string) {}
}

export class SetSupplierCompatibilitiesAction {
  public static readonly type = '[QuoteMeta] Set Supplier Compatibilities'
  constructor(public payload: { [key: string]: string[] }) {}
}

export class SetOrderFeedAction {
  public static readonly type = '[QuoteMeta] Set Order Feed'
  constructor(public payload: any[]) {}
}

export class SetPaymentStatusAction {
  public static readonly type = '[QuoteMeta] Set Payment Status'
  constructor(public payload: string) {}
}

export class SetOrderStatusAction {
  public static readonly type = '[QuoteMeta] Set Order Status'
  constructor(public payload: string) {}
}

export class SetOrderInstallationStatusAction {
  public static readonly type = '[QuoteMeta] Set Order Delivery Status'
  constructor(public payload: string) {}
}

export class SetUploadedFilesAction {
  public static readonly type = '[QuoteMeta] Set Uploaded Files'
  constructor(public payload: any[]) {}
}

export class ChangeProposalBYDNumberAction {
  public static readonly type = '[QuoteMeta] Change Proposal BYD Number'
  constructor(public payload: any) {}
}

export class ChangeProposalInvoiceNumberAction {
  public static readonly type = '[QuoteMeta] Change Proposal BYD Number'
  constructor(public payload: any) {}
}

export class ChangeReferenceAction {
  public static readonly type = '[QuoteMeta] Change Reference'
  constructor(public payload: any) {}
}

export class SetTotvsCodeAction {
  public static readonly type = '[QuoteMeta] Set Totvs Code'
  constructor(public payload: string) {}
}

export class ResetQuoteDataAction {
  public static readonly type = '[QuoteMeta] Reset Quote Data'
}

export class SetKitCompositionAction {
  public static readonly type = '[QuoteMeta] Set Kit Composition'
  constructor(public payload: IQuoteItem[]) {}
}

export class SetCurrentTabAction {
  public static readonly type = '[QuoteMeta] Set Current Tab'
  constructor(public payload: number) {}
}

export class SetExternalUserAction {
  public static readonly type = '[QuoteMeta] Set External User'
  constructor(public payload: IUser) {}
}

export class SetCommissionValuesAction {
  public static readonly type = '[QuoteMeta] Set Commission Values'
  constructor(public payload: IInstallationValues) {}
}

export class SetIntegratorAction {
  public static readonly type = '[QuoteMeta] Set Integrator'
  constructor(public payload: ILinkIntegrator) {}
}

export class SetIsEditIntegratorAction {
  public static readonly type = '[QuoteMeta] Reload Proposal State'
  constructor(public payload: boolean) {}
}

export class SetProposalIntegratorAction {
  public static readonly type = '[QuoteMeta] Set Proposal Integrator'
  constructor(public payload: ILinkIntegrator) {}
}

export class ResetInstallationValuesAction {
  public static readonly type = '[QuoteMeta] Reset Installation Values'
}

export class SetCheckoutKitTypeAction {
  public static readonly type = '[QuoteMeta] Set Checkout kitType State'
  constructor(public kitType: KitType) {}
}

export class ResetCheckoutKitTypeAction {
  public static readonly type = '[QuoteMeta] Reset Checkout kitType State'
}

export class SetChargerKitCompositionAction {
  public static readonly type = '[QuoteMeta] Set Charger Kit Composition'
  constructor(public payload: StoreChargers[]) {}
}

export class UpdateChargerItemQuantityAction {
  public static readonly type = '[QuoteMeta] Update Charger Item Quantity'
  constructor(public payload: { id: string; quantity?: number }) {}
}

export class SetStandardKitCompositionAction {
  public static readonly type = '[QuoteMeta] Set Standard Kit Composition'
  constructor(public payload: StoreKit[]) {}
}

export class UpdateStandardItemQuantityAction {
  public static readonly type = '[QuoteMeta] Update Standard Item Quantity'
  constructor(public payload: { id: string; quantity?: number }) {}
}
